<div id="app-header" class="d-flex justify-content-center align-items-center">
  <div class="title" (click)="goToIndex()">
      {{ text }}
  </div>
</div>
